export const routes = (prefix = `inventory-management`) => [
    {
        path: `/${prefix}/approvals`,
        name: `${prefix}.approvals.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.approvals.index`,
                PageDescription: "Inventory management: Approvals",
            },
        },
    },
];
